<template>
  <li class="dropdown tw-relative">
    <a
      class="tw-text-xs waves-effect tw-leading-none tw-text-current tw-px-2 tw-py-2 tw-rounded tw-flex tw-items-center tw-uppercase"
    >
      <img
        :src="'/imgs/flags/' + selectedLanguage + '.svg'"
        class="tw-w-5 tw-mr-2"
      />
      {{ languageMappings[selectedLanguage] }}
      <i class="fas fa-chevron-down tw-ml-1"></i>
    </a>
    <div
      class="tw-absolute tw-top-0 tw-mt-8 tw-rounded tw-shadow-md tw-bg-gray-200 dropdown-content tw-min-w-0"
    >
      <div class="tw-w-full tw-flex tw-flex-col">
        <a
          class="tw-text-xs tw-leading-none tw-px-4 tw-py-2 tw-rounded tw-flex tw-items-center tw-text-gray-900 tw-cursor-pointer"
          @click="selectedLanguage = 'en'"
        >
          <img src="/imgs/flags/en.svg" class="tw-w-5 tw-mr-2" /> US
        </a>
        <a
          class="tw-text-xs tw-leading-none tw-px-4 tw-py-2 tw-rounded tw-flex tw-items-center tw-text-gray-900 tw-cursor-pointer"
          @click="selectedLanguage = 'pt_br'"
        >
          <img src="/imgs/flags/pt_br.svg" class="tw-w-5 tw-mr-2" /> BR
        </a>
        <a
          class="tw-text-xs tw-leading-none tw-px-4 tw-py-2 tw-rounded tw-flex tw-items-center tw-text-gray-900 tw-cursor-pointer"
          @click="selectedLanguage = 'fr'"
        >
          <img src="/imgs/flags/fr.svg" class="tw-w-5 tw-mr-2" /> FR
        </a>
        <a
          class="tw-text-xs tw-leading-none tw-px-4 tw-py-2 tw-rounded tw-flex tw-items-center tw-text-gray-900 tw-cursor-pointer"
          @click="selectedLanguage = 'es'"
        >
          <img src="/imgs/flags/es.svg" class="tw-w-5 tw-mr-2" /> ES
        </a>
        <a
          class="tw-text-xs tw-leading-none tw-px-4 tw-py-2 tw-rounded tw-flex tw-items-center tw-text-gray-900 tw-cursor-pointer"
          @click="selectedLanguage = 'it'"
        >
          <img src="/imgs/flags/it.svg" class="tw-w-5 tw-mr-2" /> IT
        </a>
      </div>
    </div>
    <form
      action="/switch-lang"
      method="POST"
      class="tw-hidden"
      id="switch-lang"
    >
      <input type="hidden" name="_token" :value="token" />
      <input
        type="hidden"
        name="language"
        id="language"
        :value="selectedLanguage"
      />
    </form>
  </li>
</template>

<script>
export default {
  props: ["language", "token"],
  data() {
    return {
      languageMappings: {
        pt_br: "BR",
        en: "US",
        fr: "FR",
        es: "ES",
        it: "IT"
      },
      selectedLanguage: this.language
    };
  },
  methods: {
    switchLanguage() {
      document.querySelector("#language").value = this.selectedLanguage;
      document.querySelector("#switch-lang").submit();
    }
  },
  watch: {
    selectedLanguage(newVal, oldVal) {
      this.switchLanguage();
    }
  }
};
</script>

<style></style>
